// Inlined at build time by Next.js. Must be provided to `next build`.
export const API_URL = process.env.NEXT_PUBLIC_API_URL ?? "";

/**
 * Fills a user slug into an endpoint template. The slug reaches us decoded from the page url, so it is
 * percent encoded here: a slug outside Latin-1 makes the node http client throw before it sends, and one
 * inside it goes out raw and is rejected by the API.
 * @param endpoint The endpoint template carrying a `:userId` or `:userId?` segment
 * @param slug The user slug, blank on endpoints that resolve the user from the auth token
 * @returns The endpoint with the slug segment filled in
 */
export function withUserSlug(endpoint: string, slug?: string | null) {
    const encoded = encodeURIComponent(slug ?? "");

    return endpoint.replace(":userId?", encoded).replace(":userId", encoded);
}
